<template>
  <div v-if="page_loading">
    <loading :page_loading="page_loading" />
  </div>
  <div v-else>
    <loading :loading="loading" />
    <v-container fluid class="pa-0">
      <v-row no-gutters>
        <!-- ฝั่งซ้าย: Preview ฉลาก -->
        <v-col cols="7" class="grey lighten-2 d-flex justify-center align-center" style="min-height: 100vh;" >
          <div id="print-area">
            <div v-for="(p,index) in Data" :key="index">
              <div v-for="(item,index) in p.order" :key="index">
                <v-card v-if="INV_Print.ShopID == 8985" :elevation="0" width="793" style="break-after:page"  class="font">
                    <v-row justify="center" >
                        <v-col cols="12" align="left" class="py-0 pl-0" v-if="INV_Print.titleprint_main.text != 'ใบส่งสินค้า' || companyInfoSelect">
                            <v-row >
                              <v-col cols="2" class=" pl-1 py-0" >
                                <p>
                                  <img class="size-pic" :src="'https://s3-ap-southeast-1.amazonaws.com/taobao2yous3/tb2uuploads/user/2025-07/f901d4e6202507300341321.png'"
                                  >
                                </p>
                              </v-col>
                              <v-col cols="10" class="px-0 pl-1 py-0">
                                <h4 class="mb-1 font-weight-bold">{{item.shopAddress.name}}</h4>
                                <h5 class="mb-1 font-weight-bold">76/19 หมู่ 13 ถนนกาญจนาภิเษก ตำบลบางม่วง อำเภอบางใหญ่ จังหวัดนนทบุรี 11140</h5>
                                <h5 class="mb-1 font-weight-bold">โทรศัพท์ 066-0952641 Email : sabaipers@gmail.com</h5>
                                <h5 class="mb-1 font-weight-bold">เลขประจำตัวผู้เสียภาษี 0125568015561 (สำนักงานใหญ่)</h5>
                              </v-col>
                            </v-row>
                        </v-col>

                        <v-col cols="12" align="center" class="py-0 pl-0" v-if="INV_Print.titleprint_main.text != 'ใบส่งสินค้า' || companyInfoSelect">
                          <v-divider color="black" class="force-black" style="height: 10px; background-color: black;"></v-divider>
                        </v-col>
                        <v-col cols="12" class="py-0" style="height: 40px" v-if="INV_Print.titleprint_main.text == 'ใบส่งสินค้า' && !companyInfoSelect"></v-col>
                        <v-col cols="12" align="center" class="py-0 pl-0 pt-2 pb-2">
                          <h4 class="mb-1 font-weight-bold">
                            {{INV_Print.titleprint_main.text == "ใบเสนอราคา"? 'ต้นฉบับใบเสนอราคา/Quotation' : INV_Print.titleprint_main.text}}
                            {{INV_Print.titleprint_main.text != "ใบเสนอราคา" && INV_Print.titleprint_secondary.value != 0 ? "/"+p.titleprint_secondary.text : '' }}
                          </h4>
                        </v-col>
                        <v-col cols="12" align="left" class="py-0 pl-0">
                            <v-row >
                              <!-- ===== ซ้าย (8) ===== -->
                              <v-col cols="8" class="py-0">
                                <v-row >
                                  <v-col cols="3" class="pl-0 py-0">
                                    <h5 class="mb-1 font-weight-regular" style="white-space: nowrap; font-size: 11.5px;">{{ namedepartmentLabel }}</h5>
                                  </v-col>
                                  <v-col cols="8" class="px-0 py-0">
                                    <h5 class="mb-1 font-weight-bold">{{namedepartment}}</h5>
                                  </v-col>
                                </v-row>
                                <v-row >
                                  <v-col cols="3" class="pl-0 py-0">
                                    <h5 class="mb-1 font-weight-regular" style="white-space: nowrap; font-size: 11.5px;">{{ departmentLabel }}</h5>
                                  </v-col>
                                  <v-col cols="8" class="px-0 py-0">
                                    <h5 class="mb-1 font-weight-bold">{{department}}</h5>
                                  </v-col>
                                </v-row>
                                <v-row  v-if="taxID != ''">
                                  <v-col cols="3" class="pl-0 py-0">
                                    <h5 class="mb-1 font-weight-regular" style="white-space: nowrap; font-size: 11.5px;">เลขประจำตัวผู้เสียภาษี</h5>
                                  </v-col>
                                  <v-col cols="8" class="px-0 py-0">
                                    <h5 class="mb-1 font-weight-bold">{{ taxID }}</h5>
                                  </v-col>
                                </v-row>
                                <v-row >
                                  <v-col cols="3" class="pl-0 py-0">
                                    <h5 class="mb-1 font-weight-regular" style="white-space: nowrap; font-size: 11.5px;">ที่อยู่</h5>
                                  </v-col>
                                  <v-col cols="9" class="px-0 py-0">
                                    <h5 v-if="item.customerAddress.province == 'กรุงเทพมหานคร'" class="mb-1 font-weight-bold">
                                      {{ item.customerAddress.address + ' แขวง' + item.customerAddress.tumbon + ' เขต' + item.customerAddress.amphoe + ' จังหวัด' + item.customerAddress.province + ' ' + item.customerAddress.postcode }}
                                    </h5>
                                    <h5 v-else class="mb-1 font-weight-bold">
                                      {{ item.customerAddress.address + ' ตำบล' + item.customerAddress.tumbon + ' อำเภอ' + item.customerAddress.amphoe + ' จังหวัด' + item.customerAddress.province + ' ' + item.customerAddress.postcode }}
                                    </h5>
                                  </v-col>
                                </v-row>
                                <v-row >
                                  <v-col cols="3" class="pl-0 py-0">
                                    <h5 class="mb-1 font-weight-regular" style="white-space: nowrap; font-size: 11.5px;">โทรศัพท์</h5>
                                  </v-col>
                                  <v-col cols="8" class="px-0 py-0">
                                    <h5 class="mb-1 font-weight-bold">{{phoneNumber}}</h5>
                                  </v-col>
                                </v-row>
                              </v-col>

                              <!-- ===== ขวา (4) ===== -->
                              <v-col cols="4" class="py-0">
                                <v-row >
                                  <v-col cols="6" class="pl-0 py-0">
                                    <h5 class="mb-1 font-weight-regular" align="left">วันที่</h5>
                                  </v-col>
                                  <v-col cols="6" class="px-0 py-0">
                                    <h5 class="mb-1 font-weight-bold">{{ toBuddhistDate(item.dateString) }}</h5>
                                  </v-col>
                                </v-row>
                                <v-row  v-if="INV_Print.titleprint_main.text != 'ใบส่งของ' && INV_Print.titleprint_main.text != 'ใบส่งสินค้า' && INV_Print.titleprint_main.text!='ใบเสนอราคา'">
                                  <v-col cols="6" class="pl-0 py-0">
                                    <h5 class="mb-1 font-weight-regular" align="left">เลขที่ใบเสร็จ</h5>
                                  </v-col>
                                  <v-col cols="6" class="px-0 py-0">
                                    <h5 class="mb-1 font-weight-bold">{{ item.receiptNo }}</h5>
                                  </v-col>
                                </v-row>
                                <v-row  v-if="INV_Print.titleprint_main.text == 'ใบเสนอราคา'">
                                  <v-col cols="6" class="pl-0 py-0">
                                    <h5 class="mb-1 font-weight-regular" align="left">เลขที่</h5>
                                  </v-col>
                                  <v-col cols="6" class="px-0 py-0">
                                    <h5 class="mb-1 font-weight-bold">{{ item.invoiceNo }}</h5>
                                  </v-col>
                                </v-row>
                                <v-row  v-if="INV_Print.titleprint_main.text != 'ใบเสนอราคา'">
                                  <v-col cols="6" class="pl-0 py-0">
                                    <h5 class="mb-1 font-weight-regular" align="left">{{ INV_Print.titleprint_main.text == 'ใบส่งของ' || INV_Print.titleprint_main.text == 'ใบส่งสินค้า' ? 'ใบส่งของเลขที่' : 'เลขที่อ้างอิง' }}</h5>
                                  </v-col>
                                  <v-col cols="6" class="px-0 py-0">
                                    <h5 class="mb-1 font-weight-bold">{{item.invoiceNo}}</h5>
                                  </v-col>
                                </v-row>
                              </v-col>
                            </v-row>
                        </v-col>
                        <div class="py-1">
                        <table width="99.5%" border="0" style="border-collapse: collapse; table-layout: fixed;">
                          <tr class="border-a">
                            <th class="screen-only py-2 border-right" width="4%" align="center" style="font-size: 11px;"></th>
                            <th width="5%" align="center" class="py-2 border-right" style="font-size: 11px;">ลำดับที่</th>
                            <th width="40%" align="center" class="py-2 border-right" style="font-size: 11px;">รายการ</th>
                            <th width="10%" align="center" class="py-2 border-right" style="font-size: 11px;">จำนวน</th>
                            <th width="8%" align="center" class="py-2 border-right" style="font-size: 11px;" >หน่วย</th>
                            <th v-if="priceSelect" width="10%" align="center" class="py-2 border-right" style="font-size: 11px;">ราคา/หน่วย</th>
                            <th v-if="priceSelect" width="12%" align="center" class="py-2 border-right" style="font-size: 11px;">รวมเป็นเงิน</th>
                          </tr>

                          <draggable tag="tbody" v-model="item.orderItemInvs" handle=".drag-handle">
                          <tr Valign="top" v-for="(i, index) in item.orderItemInvs" v-bind:key="index">
                            <td class="screen-only drag-handle px-2 py-1 border-x" align="center" style="font-size: 14px; cursor: grab; user-select: none;">&#8801;</td>
                            <td align="center" class="px-2 py-1 border-x" style="font-size: 11px;">{{ index + 1 }}</td>
                            <td align="left" class="px-2 py-1 border-right" style="font-size: 11px;">
                              <span
                                contenteditable="true"
                                @blur="i.name = $event.target.innerText"
                                @keydown.enter.prevent
                                style="outline: none; display: inline-block; min-width: 10px;"
                              >{{ i.name }}</span>
                              <br v-if="i.prop1Description != null" />
                              <span
                                v-if="i.prop1Description != null"
                                contenteditable="true"
                                @blur="i.prop1Description = $event.target.innerText"
                                @keydown.enter.prevent
                                class="pl-4"
                                style="font-size: 11px; outline: none; display: inline-block; min-width: 10px;"
                              >{{ i.prop1Description + (i.prop2Description == null ? "" : ", " + i.prop2Description) }}</span>
                            </td>
                            <td v-if="INV_Print.ShopID == 8985" align="center" class="px-2 py-1 border-right" style="font-size: 11px;">
                              {{ format_number(i.quantity) }}
                              <div v-if="i.quantityUomText && (INV_Print.titleprint_main.text == 'ใบส่งสินค้า' || INV_Print.titleprint_main.text == 'ใบส่งของ')" style="font-size: 10px;">(<span
                                contenteditable="true"
                                @blur="i.quantityUomText = $event.target.innerText"
                                @keydown.enter.prevent
                                style="font-size: 10px; outline: none;"
                              >{{ i.quantityUomText }}</span>)</div>
                            </td>
                            <td v-if="INV_Print.ShopID != 8985" align="right" class="px-2 py-1 border-right" style="font-size: 11px;">{{ format_price(i.quantity) }}</td>
                            <td align="center" class="px-2 py-1 border-right" style="font-size: 11px;" contenteditable="true"
                                @keydown.enter.prevent>ชิ้น</td>
                            <td v-if="priceSelect" align="center" class="px-2 py-1 border-right" style="font-size: 11px;">{{ i.unitPrice.toFixed(2) }}</td>
                            <td v-if="priceSelect" align="right" class="px-2 py-1 border-right" style="font-size: 11px;">{{ format_price((i.quantity * i.unitPrice) - i.discount) }}</td>
                          </tr>
                          </draggable>

                          <tr :height="calendar_last_row_height(item.orderItemInvs.length)" Valign="top" class="border-bottom">
                            <td class="screen-only px-2 border-x"></td>
                            <td align="left" class="px-2 border-x"></td>
                            <td align="left" class="px-2 border-right"></td>
                            <td align="right" class="px-2 border-right"></td>
                            <td align="right" class="px-2 border-right"></td>
                            <td v-if="priceSelect" align="right" class="px-2 border-right"></td>
                            <td v-if="priceSelect" align="right" class="px-2 border-right"></td>
                          </tr>
                          <tr v-if="!priceSelect" class="border-a">
                            <th class="screen-only py-2 border-right"></th>
                            <th colspan="2" align="right" class="py-2 pr-2 border-right" style="font-size: 11px;">รวมจำนวนทั้งหมด</th>
                            <th align="center" class="py-2 border-right" style="font-size: 11px;">{{ format_number(item.orderItemInvs.reduce((sum, i) => sum + i.quantity, 0)) }}</th>
                            <th align="center" class="py-2 border-right" style="font-size: 11px;" 
                                contenteditable="true"
                                @keydown.enter.prevent>ชิ้น</th>
                          </tr>

                          <tr Valign="top" class="border-bottom">
                          <td v-if="bankSelect && priceSelect" align="left" colspan="3" class="px-2 py-1 border-a">
                            <div style="display: flex; align-items: center; gap: 8px; font-size: 12px;" class="py-4">
                              <span class="font-weight-bold pr-5" style="font-size: 11px;">ตัวอักษร</span>
                              <span>{{ convertNumberToThaiText(item.orderMaster.sumTotalPriceVat) }}</span>
                            </div>
                            <div v-if="INV_Print.ShopID == 8985" style="border-top: 1px solid #000; margin: 6px -8px;"></div>
                            <div v-if="INV_Print.ShopID == 8985" class="py-4" style="display: flex; align-items: center; gap: 8px; font-size: 12px;">
                              <span class="font-weight-bold pr-5" style="font-size: 11px;">ชำระเงิน</span>
                              <div style="display: flex; align-items: flex-start; gap: 8px;">
                                <img style="max-width: 20px;" src="https://s3-ap-southeast-1.amazonaws.com/taobao2yous3/tb2uuploads/user/2026-03/5e0f23a7202603241417591.png" />
                                <div>ธนาคารกรุงไทย | เลขที่บัญชี 664-6-22355-6 | บริษัท สบายเพิส จำกัด</div>
                              </div>
                            </div>
                          </td>

                          <td v-if="!bankSelect && priceSelect" align="left" colspan="3" class="px-2 py-1 border-a">
                            <span class="font-weight-bold pr-5" style="font-size: 11px;">ตัวอักษร</span>
                            <div style="text-align: center; font-size: 12px;" class="py-4">
                              <span>{{ convertNumberToThaiText(item.orderMaster.sumTotalPriceVat) }}</span>
                            </div>
                          </td>

                          <td v-if="priceSelect" align="left" colspan="2" class="px-1 py-2 border-a">
                            <v-row>
                              <v-col cols="12" align="left" class="font-weight-bold py-1 pt-1" style="font-size: 11px;">รวม</v-col>
                            </v-row>
                            <v-row>
                              <v-col v-if="item.orderMaster.vatAmount != 0 && item.orderMaster.vatAmount != ''" cols="12" align="left" class="font-weight-bold py-1" style="font-size: 11px;">
                                <span>ส่วนลด</span>
                              </v-col>
                            </v-row>
                            <v-row>
                              <v-col cols="12" align="left" class="font-weight-bold py-1" style="font-size: 11px;">
                                <span>ภาษีมูลค่าเพิ่ม 7 %</span>
                              </v-col>
                            </v-row>
                            <v-row>
                              <v-col cols="12" align="left" class="font-weight-bold py-1 pb-1" style="font-size: 11px;">รวมเป็นเงินทั้งสิ้น</v-col>
                            </v-row>
                          </td>

                          <td v-if="priceSelect" align="left" class="px-1 py-2 border-a">
                            <v-row>
                              <v-col cols="12" align="right" class="py-1" style="font-size: 11px;">
                                {{ format_price((item.orderMaster.sumTotalPrice == 0 || item.orderMaster.sumTotalPrice == '') ? 0.00 : item.orderMaster.sumTotalPrice) }}
                              </v-col>
                            </v-row>
                            <v-row>
                              <v-col v-if="item.orderMaster.vatAmount != 0 && item.orderMaster.vatAmount != ''" cols="12" align="right" class="py-1" style="font-size: 11px;">
                                {{ format_price((item.orderMaster.orderDiscount == 0 || item.orderMaster.orderDiscount == '') ? 0.00 : item.orderMaster.orderDiscount) }}
                              </v-col>
                            </v-row>
                            <v-row>
                              <v-col cols="12" align="right" class="py-1" style="font-size: 11px;">
                                {{ format_price((item.orderMaster.vatAmount == 0 || item.orderMaster.vatAmount == '') ? 0.00 : item.orderMaster.vatAmount) }}
                              </v-col>
                            </v-row>
                            <v-row>
                              <v-col cols="12" align="right" class="py-1 pb-1" style="font-size: 11px;">
                                {{ format_price(item.orderMaster.sumTotalPriceVat) }}
                              </v-col>
                            </v-row>
                          </td>
                        </tr>
                        </table>
                        <table width="99.5%" class="my-2" border="0" style="border-collapse: collapse; font-size: 11px;" v-if="INV_Print.titleprint_main.text == 'ใบเสนอราคา'">
                          <tr class="border-a" height="90px" v-if="note!=''">
                            <td  colspan="3" align="left" class="border-right">
                              <p class="mb-2 pt-2 pl-2" style="white-space: pre-line; line-height: 1.8;">หมายเหตุ {{note}}</p>
                              <!-- <p class="mb-2 pt-2">หมายเหตุ บริษัทฯ ขึ้นทะเบียน SME จากทางภาครัฐแล้ว</p>
                              <p class="mb-2 ">กรณีสั่งซื้อกรุณาลงนามยืนยันการสั่งซื้อด้านล่างนี้ หรือส่งใบสั่งซื้อของหน่วยงานมาที่โทรสาร 066-0952641</p>
                              <p class="mb-2 font-weight-bold">กำหนดยืนราคา 30 วัน กำหนดส่งมอบภายใน {{deliveryDay}} วัน</p> -->
                            </td>
                          </tr>
                          <tr class="border-a" height="120px">
                            <td width="50%" align="left" class="border-right">
                              <p class="font-weight-bold mb-0 py-1 pl-1" style="font-size: 11px;">ลงชื่อผู้มีอำนาจ</p><br>
                              <div style="text-align: center;" >
                                 <p class="mb-3">............................................................</p>
                                 <p class="mb-3">(...........................................................)</p>
                                 <p class="mb-3">................../..................../....................</p>
                              </div>
                            </td>
                             <td width="50%"  class="border-right">
                              <p class="font-weight-bold mb-0 " style="font-size: 11px;"></p><br>
                              <div style="text-align: center;" >
                                <div style="position: relative; display: flex; justify-content: center; align-items: center;">
                                 <v-img
                                    v-if="previewUrl"
                                    :src="previewUrl"
                                    max-width="100"
                                    class="mb-0 mx-auto"
                                  ></v-img>
                                  <v-img
                                    v-if="previewSealUrl"
                                    :src="previewSealUrl"
                                    max-width="100"
                                    class="mb-0"
                                    style="position: absolute; right: 8px; top: 12px;"
                                  ></v-img>
                                </div>
                                 <p v-if="!previewUrl" class="mb-3 pt-4">............................................................</p>
                                 <p class="mb-3">({{createby}})</p>
                                 <p class="mb-3 font-weight-bold">ผู้จัดทำใบเสนอราคา</p>
                              </div>
                            </td>
                          </tr>
                        </table>
                        <table width="99.5%" class="my-2" border="0" style="border-collapse: collapse; font-size: 11px;" v-if="INV_Print.titleprint_main.text == 'ใบส่งของ' || INV_Print.titleprint_main.text == 'ใบเสร็จรับเงิน' || INV_Print.titleprint_main.text== 'ใบส่งสินค้า'">
                          <p class="mb-3">ได้รับสินค้าครบถ้วนทุกรายการแล้ว</p>
                          <tr class="border-a" height="120px">
                            <td width="50%" class="border-right">
                              <div style="text-align: center;" >
                                 <p class="mb-3 pt-5">(...........................................................)</p>
                                 <p class="mb-3" v-if="INV_Print.titleprint_main.text == 'ใบส่งของ' || INV_Print.titleprint_main.text== 'ใบส่งสินค้า'">ผู้ส่งสินค้า</p>
                                 <p class="mb-3" v-if="INV_Print.titleprint_main.text == 'ใบเสร็จรับเงิน'">ผู้จ่ายเงิน</p>
                                 <p class="mb-3">วันที่................/................../..................</p>
                              </div>
                            </td>
                             <td width="50%"  class="border-right">
                              <div style="text-align: center;" >
                                <div style="position: relative; display: flex; justify-content: center; align-items: center;">
                                 <v-img
                                    v-if="previewUrl"
                                    :src="previewUrl"
                                    max-width="100"
                                    class="mb-0 mx-auto"
                                  ></v-img>
                                  <v-img
                                    v-if="previewSealUrl"
                                    :src="previewSealUrl"
                                    max-width="100"
                                    class="mb-0"
                                    style="position: absolute; right: 8px; top: 12px;"
                                  ></v-img>
                                </div>
                                 <p v-if="!previewUrl" class="mb-3 pt-5">(...........................................................)</p>
                                 <p class="mb-3" v-if="INV_Print.titleprint_main.text == 'ใบส่งของ' || INV_Print.titleprint_main.text== 'ใบส่งสินค้า'">ผู้รับสินค้า</p>
                                 <p class="mb-3" v-if="INV_Print.titleprint_main.text == 'ใบเสร็จรับเงิน'">ผู้รับเงิน</p>
                                 <p class="mb-3">วันที่................/................../..................</p>
                              </div>
                            </td>
                          </tr>
                        </table>
                        <table v-if="INV_Print.titleprint_main.text == 'ใบส่งสินค้า' && docListSelect" width="99.5%" class="mt-3" border="0" style="border-collapse: collapse; font-size: 11px;">
                          <tr>
                            <td width="22%" style="vertical-align: top; padding: 8px 4px;"></td>
                            <td width="39%" align="left" style="vertical-align: top; padding: 8px 4px; font-weight: 600;">รายการเอกสารกรณี ลูกค้ามารับเองที่คลัง</td>
                            <td width="39%" align="left" style="vertical-align: top; padding: 8px 4px; font-weight: 600;">รายการเอกสารก่อนนำสินค้าออกจากคลัง</td>
                          </tr>
                          <tr>
                            <td style="vertical-align: top; padding: 8px 4px; font-weight: 600;">รายการเอกสารก่อนจัดเตรียมสินค้า</td>
                            <td style="vertical-align: top; padding: 8px 4px;">
                              <div class="mb-2">1.สำเนาบัตรประชาชนผู้เข้ารับสินค้า</div>
                              <div class="mb-2">2.ทะเบียนรถ/ชนิดของรถ</div>
                              <div class="mb-2">3.ชื่อคนขับและเบอร์โทรติดต่อ</div>
                            </td>
                            <td style="vertical-align: top; padding: 8px 4px;">
                              <div class="mb-2">1.ถ่ายรูปทะเบียนรถ</div>
                              <div class="mb-2">2.ถ่ายรูปบัตรประชาชนผู้รับสินค้า</div>
                              <div class="mb-2">3.ถ่ายรูปผู้รับสินค้า</div>
                              <div class="mb-2">4.ถ่ายรูปขณะขึ้นสินค้าและบรรจุสินค้าเรียบร้อย</div>
                              <div class="mb-2">5.เอกสารเซ็นต์รับก่อนนำสินค้าออกจากคลัง</div>
                            </td>
                          </tr>
                        </table>
                      </div>
                      </v-row>

                </v-card>
                <v-card v-if="Sizepage=='a4' && INV_Print.ShopID != '8985'" :elevation="0" width="793"  style="break-after:page" >
                    <v-card-text>
                      <!-- ส่วนหัว -->
                      <v-row justify="center" >
                        <v-col cols="7" align="left" class="py-0 pl-0">
                            <v-row >
                              <v-col cols="2" class="px-0 pl-1 py-0 mt-1" v-if="item.shopAddress.shopLogo != null">
                                <p>
                                  <img class="size-pic" :src="item.shopAddress.shopLogo == null ? '' : item.shopAddress.shopLogo" >
                                </p>
                              </v-col>
                              <v-col cols="10" class="px-0 pl-1 py-0">
                                <p  class="mb-0 font-weight-bold">{{item.shopAddress.name}}</p>
                                <div v-if="item.shopAddress.address != null">
                                  <p v-if="item.shopAddress.province == 'กรุงเทพมหานคร'" class="mb-0">
                                    {{  item.shopAddress.address + ' แขวง' + item.shopAddress.tumbon + ' เขต' + item.shopAddress.amphoe + ' จังหวัด' + item.shopAddress.province + ' ' + item.shopAddress.postcode}}
                                  </p>
                                  <p v-else class="mb-0">
                                    {{  item.shopAddress.address + ' ตำบล' + item.shopAddress.tumbon + ' อำเภอ' + item.shopAddress.amphoe + ' จังหวัด' + item.shopAddress.province + ' ' + item.shopAddress.postcode}}
                                  </p>
                                </div>
                                <p class="mb-0" v-if="checkbox_shoptel && item.shopAddress.phone != null">
                                  {{use_language.tel}} {{item.shopAddress.phone}}
                                </p>
                                <p class="mb-0" v-if="item.shopAddress.idcardNumber != null ">
                                  {{use_language.tax_invoice_number}} {{item.shopAddress.idcardNumber}}
                                </p>
                              </v-col>
                            </v-row>
                        </v-col>
                        <v-col cols="5" align="right" class="py-0">
                            <p class="headline mb-1">
                              <span>{{p.titleprint_main.text}}</span>
                              <span v-if="p.titleprint_secondary != null && p.titleprint_secondary.value != 0">
                                / {{p.titleprint_secondary.text}}
                              </span>
                            </p>
                        </v-col>
                      </v-row>
                    
                    <v-row >
                          <v-col cols="7"  align="left" class="py-1 pl-0">
                              <!-- ข้อมูลลูกค้า -->
                              <v-row justify="center">
                                  <v-col cols="3" class="font-weight-bold py-1 pl-0"> {{use_language.customer_name}} : </v-col>
                                  <v-col cols="9" class="py-1" v-if="item.customerAddress !=null"> {{item.customerAddress.name}} </v-col>
                                  <v-col cols="9" class="py-1" v-else>  </v-col>
                              </v-row>
                              <v-row justify="center" v-if="checkbox_shipingtel == true">
                                  <v-col cols="3" class="font-weight-bold py-1 pl-0"> {{use_language.tel}} : </v-col>
                                  <v-col cols="9" class="py-1" v-if="item.customerAddress !=null"> {{item.customerAddress.phone}} </v-col>
                                  <v-col cols="9" class="py-1" v-else>  </v-col>
                              </v-row>
                              <v-row justify="center">
                                  <v-col cols="3" class="font-weight-bold py-1 pl-0">{{use_language.address}} : </v-col>
                                  <v-col cols="9" class="py-1" v-if="item.customerAddress != null">
                                    <div >
                                      <p v-if="item.customerAddress.province == 'กรุงเทพมหานคร'" class="mb-0">
                                        {{  item.customerAddress.address + ' แขวง' + item.customerAddress.tumbon + ' เขต' + item.customerAddress.amphoe + ' จังหวัด' + item.customerAddress.province + ' ' + item.customerAddress.postcode}}
                                      </p>
                                      <p v-else class="mb-0"> 
                                        {{ item.customerAddress.address + ' ตำบล' + item.customerAddress.tumbon + ' อำเภอ' + item.customerAddress.amphoe + ' จังหวัด' + item.customerAddress.province + ' ' + item.customerAddress.postcode}}
                                      </p>
                                    </div>
                                  </v-col>
                                  <v-col cols="9" class="py-1" v-else>  </v-col>
                              </v-row>
                              <v-row justify="center" v-if="item.customerAddress !=null && item.customerAddress.idcardNumber != null">
                                  <v-col cols="3" class="font-weight-bold py-1 pl-0">{{use_language.tax_invoice_number}} :</v-col>
                                  <v-col cols="9" class="py-1" v-if="item.customerAddress !=null"> {{item.customerAddress.idcardNumber}} </v-col>
                                  <v-col cols="9" class="py-1" v-else>  </v-col>
                              </v-row >
                          </v-col>
                          <v-col cols="5" class="py-1">
                              <v-row v-if="typeOfBill == 3 || typeOfBill == 4">
                                <v-col cols="4"  md="5" lg="5" align="right" class="font-weight-bold py-1">
                                  {{use_language.no_2}} : 
                                </v-col>
                                <v-col cols="8" md="7" lg="7" align="right" class="py-1">
                                  {{typeOfBill == 3 ? genReceiptNo : genDeliveryNo}}
                                </v-col>
                              </v-row>
                              <v-row>
                                  <v-col cols="4"  md="5" lg="5" align="right" class="font-weight-bold py-1">{{use_language.no_2}} : </v-col>
                                  <v-col cols="8" md="7" lg="7" align="right" class="py-1" v-if="item.invoiceNo != null">
                                    <div v-if="typeOfBill == 1">
                                      {{INV_Print.billNo}}
                                    </div>
                                    <div v-else>
                                      {{item.invoiceNo}}
                                    </div>
                                  </v-col>
                              </v-row>
                              <v-row>
                                  <v-col cols="4"  md="5" lg="5" align="right" class="font-weight-bold py-1">{{use_language.date}} : </v-col>
                                  <v-col cols="8" md="7" lg="7" align="right" class="py-1" v-if="item.dateString != null">{{item.dateString}}</v-col>
                              </v-row>
                          </v-col>
                      </v-row>
                      <div class="py-3">
                        <table width="100%" border="0" style="border-collapse: collapse;">
                          <tr class="border-a">
                            <th width="2%" align="center" class="py-2 border-right">
                              {{use_language.number}}<br>
                              No
                            </th>
                            <th width="50%" align="center" class="py-2 border-right">
                              {{use_language.list}}<br>
                              Order
                            </th>
                            <th width="12%" align="center" class="py-2 border-right">
                              {{use_language.quantity}}<br>
                              Quantity
                            </th>
                            <th v-if="typeOfBill != 4 || checkbox_ppu == true" width="12%" align="center" class="py-2 border-right">
                              {{use_language.unit_price}} <br>
                              Unit Price
                            </th>
                            <th v-if="typeOfBill != 4" width="12%" align="center" class="py-2 border-right" >
                              {{use_language.discount}} <br>
                              Discount
                            </th>
                            <th v-if="typeOfBill != 4" width="12%" align="center" class="py-2">
                              {{use_language.amount}} <br>
                              Amount
                            </th>
                          </tr>
                          <tr  Valign="top" v-for="(i,index) in item.orderItemInvs"  v-bind:key="index">
                            <td align="center" class="px-2 border-x">{{index+1}}</td>
                            <td align="left" class="px-2 border-right">{{i.name}}
                              <br v-if="i.prop1Description != null">
                              <span v-if="i.prop1Description != null" class="pl-4" style="font-size: 11px;"> {{ use_language.type }} : {{ i.prop1Description + (i.prop2Description==null? "":", "+i.prop2Description)}}</span>

                            </td>
                            <td align="right" class="px-2 border-right">{{i.quantity}}</td>
                            <td v-if="typeOfBill != 4 || checkbox_ppu == true" align="right" class="px-2 border-right">{{i.unitPrice}}</td>
                            <td v-if="typeOfBill != 4" align="right" class="px-2 border-right">{{format_price(i.discount)}}</td>
                            <td v-if="typeOfBill != 4" align="right" class="px-2 border-right">{{format_price((i.quantity*i.unitPrice)-i.discount)}}</td>
                          </tr>
                          <tr  :height="calendar_last_row_height(item.orderItemInvs.length)" Valign="top" class="border-bottom">
                            <td align="left" class="px-2 border-x"></td>
                            <td align="left" class="px-2 border-right"></td>
                            <td align="right" class="px-2 border-right"></td>
                            <td v-if="typeOfBill != 4 || checkbox_ppu == true" align="right" class="px-2 border-right"></td>
                            <td v-if="typeOfBill != 4" align="right" class="px-2 border-right"></td>
                            <td v-if="typeOfBill != 4" align="right" class="px-2 border-right"></td>
                          </tr>
                          <tr Valign="top" class="border-bottom" height="120">
                            <td align="left" :colspan="typeOfBill != 4 ? '2' : '6'" class="px-2 py-1 border-a">
                              <span class="font-weight-bold">{{use_language.note}} / remark</span><br>
                              <span>{{ item.orderMaster.remark }}</span>
                            </td>
                            <td v-if="typeOfBill != 4" align="left" colspan="3" class="px-1 py-2 border-a">
                              <v-row >
                              <v-col cols="12" align="left" class="font-weight-bold py-0 pt-1 ">{{use_language.product_price}}</v-col>
                              </v-row>
                              <v-row>
                                <v-col cols="12" align="left" class="font-weight-bold py-0">{{use_language.freight}}</v-col>
                              </v-row>
                              <v-row>
                                <v-col cols="12" align="left" class="font-weight-bold py-0">{{use_language.discount}}</v-col>
                              </v-row>
                              <v-row>
                                <v-col cols="12" align="left" class="font-weight-bold py-0">{{use_language.value_calculated_tax}}</v-col>
                              </v-row>
                              <v-row>
                                <v-col cols="12" align="left" class="font-weight-bold py-0">
                                  <span v-if="item.orderMaster.vatType== 1">{{use_language.vat}}</span>
                                  <span v-else-if="item.orderMaster.vatType== '' || item.orderMaster.vatType== null ">{{use_language.vat}}</span>
                                  <span v-else-if="item.orderMaster.vatType== 2">{{use_language.vat_included_}}</span>
                                  <span v-else-if="item.orderMaster.vatType== 3">{{use_language.vat_excluded_}}</span>
                                </v-col>
                              </v-row>
                              <v-row>
                                <v-col cols="12" align="left" class="font-weight-bold py-0 pb-1">{{use_language.total_amount}}</v-col>
                              </v-row>
                            </td>
                            <td v-if="typeOfBill != 4" align="left" class="px-1 py-2 border-a">
                              <v-row >
                                <v-col cols="12" align="right" class="py-0 pt-1">
                                  {{format_price((item.orderMaster.totalPrice == 0 || item.orderMaster.totalPrice == '') ? 0.00 : item.orderMaster.totalPrice)}}
                                </v-col>
                              </v-row>
                              <v-row>
                                <v-col cols="12" align="right" class="py-0 ">
                                  {{format_price((item.orderMaster.deliveryCost == 0 || item.orderMaster.deliveryCost == '') ? 0.00 : item.orderMaster.deliveryCost)}}
                                </v-col>
                              </v-row>
                              <v-row>
                                <v-col cols="12" align="right" class="py-0 ">
                                  {{format_price((item.orderMaster.orderDiscount == 0 || item.orderMaster.orderDiscount == '') ? 0.00 : -  item.orderMaster.orderDiscount)}}
                                  </v-col>
                              </v-row>
                              <v-row>
                                <v-col cols="12" align="right" class="py-0 ">
                                  {{format_price((item.orderMaster.sumTotalPrice == 0 || item.orderMaster.sumTotalPrice  == '') ? 0.00 : (item.orderMaster.sumTotalPrice ))}}
                                  </v-col>
                              </v-row>
                              <v-row>
                                <v-col cols="12" align="right" class="py-0 ">
                                  {{format_price((item.orderMaster.vatAmount == 0 || item.orderMaster.vatAmount == '') ? 0.00 : item.orderMaster.vatAmount)}}
                                </v-col>
                              </v-row>
                              <v-row>
                                <v-col cols="12" align="right" class="py-0 pb-1">
                                  {{format_price(item.orderMaster.sumTotalPriceVat)}}
                                </v-col>
                              </v-row>
                            </td>
                          </tr>
                        </table>
                        <table width="100%" class="my-2" border="0" style="border-collapse: collapse;">
                          <tr class="border-a" height="120px">
                            <td width="5%" align="center" class="py-2 border-right">
                              <p class="mb-2"></p>
                              <p class="mb-2 mt-4"> {{use_language.consignee}} </p>
                              <p class="mb-2">{{use_language.date}}........................</p>
                            </td>
                            <td width="5%" align="center" class="py-2 border-right">
                              <p class="mb-2"></p>
                              <p class="mb-2 mt-4"> {{use_language.shipper}} </p>
                              <p class="mb-2">{{use_language.date}}........................</p>
                            </td>
                            <td width="5%" align="center" class="py-2 border-right">
                              <div v-if="eSignatureSelect == true || eSealSelect == true">
                                <v-img
                                  v-if="eSignatureSelect"
                                  :src="eSignature"
                                  max-width="100"
                                ></v-img>
                                <v-img
                                  v-else
                                  :src="eSeal"
                                  max-width="100"
                                  class="mb-2"
                                ></v-img>
                              </div>
                              <div v-else>
                                <p class="mb-2"></p>
                                <p class="mb-2 mt-4" v-if="INV_Print.titleprint_main.text=='ใบส่งของ'|| p.titleprint_secondary.text=='ใบส่งของ'"> {{use_language.forwarder}} </p>
                                <p class="mb-2 mt-4" v-else> {{use_language.on_behalf}} </p>
                              </div>
                            </td>
                          </tr>
                        </table>
                      </div>
                    </v-card-text>
                </v-card>

                <v-card v-if="Sizepage !='a4' && INV_Print.ShopID != '8985'" class="pages font-size-print pb-2" :elevation="0" style="break-after:page">
                  <v-row justify="center" >
                    <v-col cols="8" md="12" lg="12"  align="center" class="py-0 ">
                     

                      <div v-if="item.shopAddress.province == 'กรุงเทพมหานคร'">
                        <p  class="mb-0 mt-3 font-weight-bold">{{item.shopAddress.name}}</p>
                        <!-- <p class="mb-0" v-if="checkbox_shopaddress">{{item.shopAddress['TextAddress']}}</p> -->
                        <p class="mb-0" v-if="checkbox_shopaddress">
                          {{item.shopAddress.address + ' แขวง' + item.shopAddress.tumbon }}
                        </p>
                          <p class="mb-0" v-if="checkbox_shopaddress">
                          {{ 'เขต' + item.shopAddress.amphoe + ' ' + item.shopAddress.province + ' ' +
                            item.shopAddress.postcode }}
                        </p>
                      </div>
                      <div v-else>
                        <p  class="mb-0 mt-3 font-weight-bold">{{item.shopAddress.name}}</p>
                        <!-- <p class="mb-0" v-if="checkbox_shopaddress">{{item.shopAddress['TextAddress']}}</p> -->
                        <p class="mb-0" v-if="checkbox_shopaddress">
                          {{item.shopAddress.address + ' ตำบล' + item.shopAddress.tumbon    }}
                        </p>
                         <p class="mb-0" v-if="checkbox_shopaddress">
                          {{ 'อำเภอ' + item.shopAddress.amphoe + ' ' + item.shopAddress.province + ' ' +
                            item.shopAddress.postcode }}
                        </p>
                      </div>

                      <p class="mb-0" v-if="checkbox_shoptel && item.shopAddress.phone != null ">
                        {{use_language.tel}} {{item.shopAddress.phone}}
                      </p>
                      <p class="mb-0" v-if="item.shopAddress.idcardNumber != null ">
                        {{use_language.tax_invoice_number}} {{item.shopAddress.idcardNumber}}
                      </p>
                      <p class="mb-0" v-if="checkbox_vat">
                        {{item.orderMaster.vatType== 2 ?"(VAT Included)" : "(VAT Excluded)"}}
                      </p>
                      <p class="mb-2 fonttitle-print">
                        <span>{{INV_Print.titleprint_main.text}}</span>
                        <span v-if="p.titleprint_secondary.length != 0 && p.titleprint_secondary.text != null && p.titleprint_secondary.text != '' ">
                          / {{p.titleprint_secondary.text}}
                        </span>
                        <span v-if="checkbox_abbreviated">{{ use_language.abbreviated }}</span>
                      </p>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="3" md="3" lg="3" align="left" class="font-weight-bold py-0  px-1">{{use_language.no_2}} : </v-col>
                    <v-col cols="9" md="9" lg="9" align="left" class="py-0 px-0" v-if="item.invoiceNo != null">{{item.invoiceNo}}</v-col>
                  </v-row>
                  <v-row  >
                    <v-col cols="3" md="3" lg="3" align="left" class="font-weight-bold py-0  px-1">{{use_language.date}} : </v-col>
                    <v-col cols="9" md="4" lg="4" align="left" class="py-0 px-0" v-if="item.dateString != null">{{ item.dateString }}</v-col>
                  </v-row>
                  <v-row class="pb-1">
                    <v-col cols="3" md="3" lg="3" align="left" class="font-weight-bold py-0  px-1">{{ use_language.order }} :
                    </v-col>
                    <v-col cols="9" md="4" lg="4" align="left" class="py-0 px-0" v-if="item.dateString != null">{{
                      format_order_id(item.orderId) }}</v-col>
                  </v-row>

                  <!-- <v-divider class="my-1" light ></v-divider> -->
                        <!-- ข้อมูลลูกค้า -->
                  <div class="border-top my-1 mx-0"  v-if="checkbox_custmer_address == true &&item.customerAddress!=null">
                    <v-row class="pt-1">
                      <v-col cols="3" align="left" class="font-weight-bold py-0 mb-0 px-1"> {{use_language.customer}} : </v-col>
                      <v-col cols="9" md="8" lg="8" align="left" class="py-0 px-0">
                        {{item.customerAddress.name}} <br>
                      </v-col>
                    </v-row>
                    <v-row class="pt-1" v-if="checkbox_shipingtel">
                      <v-col cols="3" align="left" class="font-weight-bold py-0 mb-0 px-1"> {{use_language.tel}} : </v-col>
                      <v-col cols="9" md="8" lg="8" align="left" class="py-0 px-0">
                        {{item.customerAddress.phone}} <br>
                      </v-col>
                    </v-row>
                    <v-row class="pt-1">
                      <v-col cols="3" align="left" class="font-weight-bold py-0 mb-0 px-1">
                        <!-- {{use_language.address}} :  -->
                      </v-col>
                      <v-col cols="9" md="8" lg="8" align="left" class="py-0 px-0">
                        <p v-if="item.customerAddress.province == 'กรุงเทพมหานคร'" class="mb-0">
                          {{  item.customerAddress.address + ' แขวง' + item.customerAddress.tumbon + ' เขต' + item.customerAddress.amphoe + ' จังหวัด' + item.customerAddress.province + ' ' + item.customerAddress.postcode}}
                        </p>
                        <p v-else class="mb-0">
                          {{  item.customerAddress.address + ' ตำบล' + item.customerAddress.tumbon + ' อำเภอ' + item.customerAddress.amphoe + ' จังหวัด' + item.customerAddress.province + ' ' + item.customerAddress.postcode}}
                        </p>
                      </v-col>
                    </v-row>
                    <!-- <v-row>
                      <v-col cols="8" md="8" lg="8" align="left" class="py-1 mb-0">
                        {{item.customerAddress.name}} <br>
                        {{item.customerAddress.address}}
                      </v-col>
                    </v-row> -->
                    <v-row align="left" v-if="item.customerAddress.idcardNumber != null">
                        <v-col cols="3" class="font-weight-bold py-0 mb-0">{{use_language.tax_invoice_number}} :</v-col>
                        <v-col cols="9" class="py-1 px-0"> {{item.customerAddress.idcardNumber}} </v-col>
                    </v-row >
                  </div>
                  <!-- <v-divider class="my-1" light ></v-divider> -->
                  <div class="py-1 border-top">
                    <table width="100%" border="0" style="border-collapse: collapse;">
                      <tr Valign="top" v-if="checkbox_headerdetail">
                        <th  align="left" class="pl-1  border-bottom">
                          {{use_language.list}}
                        </th>
                        <th width="50px" align="center" class="px-1  border-bottom">
                          {{use_language.quantity}}
                        </th>
                        <th width="90px" align="right" class="px-0  border-bottom">
                          {{use_language.unit_price}}
                        </th>
                        <th width="80px" align="right" class="px-1  border-bottom">
                          {{use_language.amount}}
                        </th>
                      </tr>
                      <tr    Valign="top" v-for="(i,index) in item.orderItemInvs"  v-bind:key="index"> 
                        <td align="left" class="pl-1" >{{i.name}}</td>
                        <td align="right" class="px-1"  width="50px">
                          <span v-if="checkbox_headerdetail == true && checkbox_ppu == false">{{i.quantity }}</span>
                          <span v-else-if="checkbox_headerdetail == true && checkbox_ppu == true">{{i.quantity }}</span>
                          <span v-else-if="checkbox_headerdetail == false && checkbox_ppu == false">{{i.quantity +"x"}}</span>
                          <span v-else-if="checkbox_headerdetail == false && checkbox_ppu == true">{{i.quantity +"@"+i.unitPrice}}</span>
                        </td>
                        <td align="right" class="px-0"  width="90px">
                           {{ format_price(i.unitPrice) }}
                        </td>
                        <td align="right" class="px-1" width="80px">{{format_price(i.quantity*i.unitPrice)}}</td>
                      </tr>
                      <tr Valign="top" class="border-top" v-if="checkbox_remark && item.orderMaster.remark != null">
                        <td colspan="4" align="left">
                          <v-row >
                            <v-col cols="12" class="pl-0">
                            <span>{{use_language.note}} :  {{ item.orderMaster.remark }}</span>
                            </v-col>
                          </v-row>
                        </td>
                      </tr>
                      <tr Valign="top" class="border-top">

                      </tr>  
                    </table>
                     <table width="100%" border="0" class="mt-2" style="border-collapse: collapse;">
                      <tr>
                        <td class="font-weight-bold text-right">
                          {{ use_language.product_price }}
                        </td>
                        <td class="text-right pr-2 width-130">
                          {{ format_price((item.orderMaster.totalPrice == 0 || item.orderMaster.totalPrice == '') ? 0.00
                            : item.orderMaster.totalPrice) }}
                        </td>
                      </tr>
                      <tr>
                        <td class="font-weight-bold text-right">
                          {{ use_language.discount }}
                        </td>
                        <td class="text-right pr-2 width-130">
                          {{ format_price((item.orderMaster.orderDiscount == 0 || item.orderMaster.orderDiscount ==
                            '') ? 0.00 : - item.orderMaster.orderDiscount) }}
                        </td>
                      </tr>
                      <tr>
                        <td class="font-weight-bold text-right">
                          {{ use_language.shipping_cost }}
                        </td>
                        <td class="text-right pr-2 width-130">
                          {{ format_price((item.orderMaster.deliveryCost == 0 || item.orderMaster.deliveryCost ==
                            '')
                            ? 0.00 : item.orderMaster.deliveryCost) }}
                        </td>
                      </tr>
                      
                      <tr v-if="item.orderMaster.vatType !=3"  >
                        <td class="font-weight-bold text-right" :style="[item.orderMaster.vatType==2? {borderBottom: '1px solid'}: '' ]"  >
                          {{ use_language.total_amount }}
                        </td>
                        <td class="text-right pr-2 width-130" :style="[item.orderMaster.vatType==2? {borderBottom: '1px solid'}: '' ]" >
                          {{ format_price( item.orderMaster.sumTotalPriceVat) }}
                        </td>
                      </tr>
                       
                      <tr v-if="item.orderMaster.vatType == 3 ">
                        <td class="font-weight-bold text-right">
                          {{ use_language.value_calculated_tax }}
                        </td>
                        <td class="text-right pr-2 width-130">
                          {{ format_price( item.orderMaster.sumTotalPrice) }}
                        </td>
                      </tr>

                    
                      <tr v-if="item.orderMaster.vatType ==2 || item.orderMaster.vatType == 3">
                        <td class="font-weight-bold text-right">
                          {{ use_language.vat + ' ' + item.orderMaster.vatPercent + '%' }}
                        </td>
                        <td class="text-right pr-2 width-130">
                          {{ format_price((item.orderMaster.vatAmount == 0 || item.orderMaster.vatAmount == '') ?
                            0.00 : item.orderMaster.vatAmount) }}
                        </td>
                      </tr>
                       <tr v-if="item.orderMaster.vatType == 2">
                        <td class="font-weight-bold text-right">
                          {{ use_language.price_excluding_vat }}
                        </td>
                        <td class="text-right pr-2 width-130">
                          {{ format_price(item.orderMaster.sumTotalPrice ) }}
                        </td>
                      </tr>
                       <tr v-if="item.orderMaster.vatType == 3">
                        <td class="font-weight-bold text-right">
                          {{ use_language.total_amount   }}
                        </td>
                        <td class="text-right pr-2 width-130">
                          {{ format_price(item.orderMaster.sumTotalPriceVat ) }}
                        </td>
                      </tr>
                      
                    </table>
                    <p class="my-2 text-center"  >
                      {{ item.orderMaster.vatType == 2 ? "**VAT INCLUDED**" : (item.orderMaster.vatType == 3 ? "**VAT EXCLUDED**" : "") }}
                    </p>

                  </div>
                  <div style="border-style: groove;" v-if="checkbox_Payee_AuthorizedSignatory">
                    <v-row>
                      <v-col style="min-height: 130px"></v-col>
                    </v-row>
                    <v-divider/>
                    <v-row>
                      <v-col align="center">
                        <b>{{ use_language.Payee_AuthorizedSignatory }}</b>
                      </v-col>
                    </v-row>
                  </div>
                </v-card>
              </div>
            </div>
          </div>
        </v-col>

        <!-- ฝั่งขวา: ตัวเลือกการพิมพ์ -->
        <v-col cols="5" class="pa-8 white" style="min-height: 100vh;border-left: 1px solid #868686 !important">
            <v-row v-if="typeOfBill != 1 && typeOfBill != 3 & typeOfBill != 4">
              <v-col class="pb-0" cols="12" md="12">
                <h4>{{use_language.section}} : </h4>
              </v-col>
            </v-row>
            <v-row v-if="typeOfBill != 1 && typeOfBill != 3 && typeOfBill != 4"  >
              <v-col class="pb-0" cols="12" md="4" >
                <v-select
                  ref="refinvtitleprintmain"
                  v-model="Data.titleprint_main"
                  autocomplete="off"
                  :items="typeOfBill == 2 ? inv_titleprintselect2 : inv_titleprintselect"
                  item-text="text"
                  item-value="value"
                  :label="use_language.choose_topic"
                  return-object
                  dense
                  hide-details
                  outlined
                  @change="onMainChange"
                  />
                     <template v-slot:label> <span>{{use_language.choose_topic}}</span> </template>

              </v-col>
              <v-col class="pb-0" cols="12" md="1">
                <h1 class="text-center">/</h1>
              </v-col>
              <v-col class="pb-0" cols="12" md="4">
                <v-select
                  ref="refinvtitleprintsecondary"
                  v-model="Data.titleprint_secondary"
                  autocomplete="off"
                  :items="typeOfBill == 2 ? inv_titleprintselect2 : inv_titleprintselect"
                  item-text="text"
                  item-value="value"
                  :label="use_language.choose_topic"
                  return-object
                  dense
                  hide-details
                  outlined
                  @change="onSecondaryChange"
                  />
                  <template v-slot:label> <span>{{use_language.choose_topic}}</span> </template>
              </v-col>
            </v-row>
            <div v-if="INV_Print.ShopID == 8985">
              <v-row class="pt-3">
                <v-col class="pb-0 pt-3" cols="2" md="3">
                  <v-text-field
                    label="หัวข้อ"
                    v-model="namedepartmentLabel"
                    outlined
                    hide-details
                    dense
                  />
                </v-col>
                <v-col cols="auto" style="width: 350px;"  class="pb-0">
                <v-text-field
                  label="กรอกชื่อ"
                  v-model="namedepartment"
                  outlined
                />
                </v-col>
              </v-row>
              <v-row >
                <v-col class="pb-0 pt-3" cols="2" md="3">
                  <v-text-field
                    label="หัวข้อ"
                    v-model="departmentLabel"
                    outlined
                    hide-details
                    dense
                  />
                </v-col>
                <v-col cols="auto" style="width: 350px;"  class="pb-0">
                <v-text-field
                  label="กรอกหน่วยงาน"
                  v-model="department"
                  outlined
                />
                </v-col>
              </v-row>
               <v-row >
                <v-col class="pb-0 pt-5" cols="2" md="3">
                  <h4>เลขประจำตัวผู้เสียภาษี : </h4>
                </v-col>
                <v-col cols="auto" style="width: 350px;"  class="pb-0">
                <v-text-field
                  label="กรอกเลขประจำตัวผู้เสียภาษี"
                  v-model="taxID"
                  outlined
                />
                </v-col>
              </v-row>
              <v-row >
                <v-col class="pb-0 pt-5" cols="2" md="3">
                  <h4>โทรศัพท์ : </h4>
                </v-col>
                <v-col cols="auto" style="width: 350px;"  class="pb-0">
                <v-text-field
                  label="กรอกเบอร์โทรศัพท์"
                  v-model="phoneNumber"
                  outlined
                />
                </v-col>
              </v-row>
              <v-row >
                <v-col class="pb-0 pt-5" cols="2" md="3">
                  <h4>จำนวนวันส่งมอบ : </h4>
                </v-col>
                <v-col cols="auto" style="width: 350px;"  class="pb-0">
                <v-text-field
                  label="กรอกจำนวนวัน"
                  v-model="deliveryDay"
                  outlined
                />
                </v-col>
              </v-row>
              <v-row >
                <v-col class="pb-0 pt-5" cols="2" md="3">
                  <h4>ผู้จัดทำ : </h4>
                </v-col>
                <v-col cols="auto" style="width: 350px;"  class="pb-0">
                <v-text-field
                  label="กรอกผู้จัดทำใบเสนอราคา"
                  v-model="createby"
                  outlined
                />
                </v-col>
              </v-row>
              <v-row >
                <v-col class="pb-0 pt-5" cols="2" md="3">
                  <h4>ลายเซ็น : </h4>
                </v-col>
                <v-col cols="auto"  style="width: 350px;" class="pb-0">
                    <v-file-input v-model="input_transferFileUpload" ref="input_transferFileUpload" outlined hide-details
                      dense prepend-icon="" prepend-inner-icon="mdi-file-image" @change="previewImage">
                      <template v-slot:selection="{ text }">
                        <v-chip small label color="primary">
                          {{ text }}
                        </v-chip>
                      </template>
                    </v-file-input>
                  </v-col>
              </v-row>
              <v-row >
                <v-col class="pb-0 pt-5" cols="2" md="3">
                  <h4>ตราประทับ : </h4>
                </v-col>
                <v-col cols="auto"  style="width: 350px;" class="pb-0">
                    <v-file-input v-model="input_sealFileUpload" ref="input_sealFileUpload" outlined hide-details
                      dense prepend-icon="" prepend-inner-icon="mdi-file-image" @change="previewSealImage">
                      <template v-slot:selection="{ text }">
                        <v-chip small label color="primary">
                          {{ text }}
                        </v-chip>
                      </template>
                    </v-file-input>
                  </v-col>
              </v-row>
              <v-row>
                <v-col class="pb-0 pt-5" cols="2" md="3">
                  <h4>ช่องทางชำระเงิน : </h4>
                </v-col>
                <v-col  class="pb-0 pt-5">
                     <v-checkbox
                v-model="bankSelect"
                label= "แสดง"
                hide-details
              />
                  </v-col>
              </v-row>
               <v-row v-if="this.INV_Print.titleprint_main.text=='ใบส่งสินค้า'">
                <v-col class="pb-0 pt-5" cols="2" md="3">
                  <h4>แสดงราคา : </h4>
                </v-col>
                <v-col  class="pb-0 pt-5">
                     <v-checkbox
                v-model="priceSelect"
                label= "แสดง"
                hide-details
              />
                  </v-col>
              </v-row>
               <v-row v-if="this.INV_Print.titleprint_main.text=='ใบส่งสินค้า'">
                <v-col class="pb-0 pt-5" cols="2" md="3">
                  <h4>ข้อมูลบริษัท : </h4>
                </v-col>
                <v-col  class="pb-0 pt-5">
                     <v-checkbox
                v-model="companyInfoSelect"
                label= "แสดง"
                hide-details
              />
                  </v-col>
              </v-row>
               <v-row v-if="this.INV_Print.titleprint_main.text=='ใบส่งสินค้า'">
                <v-col class="pb-0 pt-5" cols="2" md="3">
                  <h4>รายการเอกสาร : </h4>
                </v-col>
                <v-col  class="pb-0 pt-5">
                     <v-checkbox
                v-model="docListSelect"
                label= "แสดง"
                hide-details
              />
                  </v-col>
              </v-row>
              <v-row >
                <v-col class="pb-0 pt-5" cols="12" md="12">
                  <h4>หมายเหตุ : </h4>
                </v-col>
                <v-col class="pb-0" cols="12" md="12">
                    <v-textarea
                  v-model="note"
                  rows="3"
                  outlined
                />
                  </v-col>
              </v-row>
            </div>
            <v-row v-if="INV_Print.ShopID != 8985">
              <v-col class="pb-0" cols="12" md="12">
                <h4>{{use_language.choose_document_size}} : </h4>
              </v-col>
            </v-row>
             <v-row class="d-flex justify-center" v-if="INV_Print.ShopID != 8985">
              <v-col class="pb-0" cols="12">
                <v-radio-group v-model="Sizepage"  row  class="d-flex align-center" >
                  <div class="d-flex" style="gap: 40px;">
                  <v-radio :label="use_language.size_a4" value= "a4" ></v-radio>
                  <v-radio :label="use_language.size_80_mm" value= "small"></v-radio>
                  </div>
                </v-radio-group>
              </v-col>
            </v-row>
            <v-row v-if="shop.branchID != 729 && typeOfBill != 1 || INV_Print.ShopID == 8985">
              <v-col class="pb-0" cols="12" md="12">
                <h4>{{use_language.document_number}} : </h4>
              </v-col>
              <v-col class="pb-0" cols="12" md="12">
                <v-data-table
                    :headers="invorderhead"
                    :items="Data[0].order"
                    class="elevation-0 packhai-border-table"
                    hide-default-footer
                    :items-per-page="50">
                    <template v-slot:item.orderid="{ item }">{{format_order_id(item.orderId)}}</template>
                    <template v-slot:item.dateString="{ item }">
                      <v-menu
                          ref="startDateMenu"
                          v-model="item.startDateMenu"
                          :close-on-content-click="true" 
                          transition="scale-transition"
                          offset-y
                          max-width="290px"
                          min-width="290px"
                        >
                          <template v-slot:activator="{ on }">
                            <v-text-field
                              :value="item.dateString"
                              @change="value => item.date = value"
                              autocomplete="off"
                              outlined
                              prepend-inner-icon="mdi-calendar"
                              readonly
                              dense
                              hide-details
                              clearable
                              @click:clear="item.date = null; item.dateString = null"
                              v-on="on"
                            >
                            </v-text-field>
                          </template>
                          <v-date-picker
                            v-model="item.date"
                            @input="item.startDateMenu = false;updateFormattedDate(item)"
                            no-title
                            class="my-0"
                          ></v-date-picker>
                        </v-menu>
                    </template>
                    <template v-slot:item.invoiceno="{ item }">
                        <v-text-field
                          ref="refinvorder"
                          :value="item.invoiceNo"
                          @change="value => item.invoiceNo = value"
                          outlined
                          dense
                          hide-details
                          autocomplete="off"
                          />
                    </template>
                    <template v-slot:[`item.receiptNo`]="{ item }">
                        <v-text-field
                          v-model="item.receiptNo"
                          outlined
                          dense
                          hide-details
                          autocomplete="off"
                          />
                    </template>
                    <!-- <template v-slot:item.delete="{ item }">
                      <v-btn color="red" icon @click="remove_data_invoice(invoice_print.invorder.indexOf(item))">
                        <v-icon>
                          fa-trash-alt
                        </v-icon>
                      </v-btn>
                    </template> -->


                </v-data-table>
              </v-col>
              
            </v-row>
          <div>
            
            <v-card v-if="Sizepage=='a4' && INV_Print.ShopID != 8985" class="screen-only" :elevation="0" width="793">
              <v-card-text>
                <v-row>
                  <v-col cols="6" md="3" class="pa-0">
                    <v-checkbox
                      v-model="checkbox_shoptel"
                      :label="use_language.shop_phone_number"
                      hide-details
                    />
                    <template v-slot:label> <span>{{use_language.shop_phone_number}}</span> </template>
                  </v-col>
                  
                  <v-col cols="6" md="3" class="pa-0">
                    <v-checkbox
                      v-model="checkbox_shipingtel"
                      :label="use_language.customer_phone"
                      hide-details
                    />
                    <template v-slot:label> <span>{{use_language.shop_phone_number}}</span> </template>
                  </v-col>
                  <v-col v-if="typeOfBill == 4" cols="6" md="3" class="pa-0">
                    <v-checkbox
                      v-model="checkbox_ppu"
                      :label="use_language.show_price_per_piece"
                      hide-details
                    />
                    <template v-slot:label> <span>{{use_language.show_price_per_piece}}</span> </template>
                  </v-col>
                  
                </v-row>
              </v-card-text>

              <v-col  class="pb-0" cols="12" md="12" v-if="eSignature != null || eSeal != null">
                <h4 class="font-weight-bolder">{{ use_language.seal_stamp }} : </h4>
              </v-col>
              <v-card-text v-if="eSignature != null || eSeal != null">
                <v-row>
                  <v-col v-if="eSignature != null" cols="6" md="3" class="pa-0">
                    <v-checkbox
                      v-model="eSignatureSelect"
                      :label="use_language.signature_label"
                      hide-details
                    />
                  </v-col>
                  <v-col v-if="eSeal != null" cols="6" md="3" class="pa-0">
                    <v-checkbox
                      v-model="eSealSelect"
                      :label="use_language.seal_stamp"
                      hide-details
                    />
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
              
            <!-- <v-card v-if="Sizepage!='a4'" class="screen-only" :elevation="0" width="793">
              <v-card-text>
                <v-row>
                  <v-col cols="6" md="6" class="pa-0">
                    <v-checkbox
                      v-model="checkbox_createdate_order"
                      label= "กำหนดวันที่ให้เป็นวันที่สร้างออเดอร์"
                      hide-details
                    />
                  </v-col>
                  <v-col cols="6" md="6" class="pa-0">
                    
                    <template v-slot:label> <span>{{use_language.Payee_AuthorizedSignatory}}</span> </template>
                  </v-col>
                </v-row>
                
               


             

              </v-card-text>
            </v-card> -->
            <div v-if="Sizepage!='a4'">
              <v-row    class="pb-4">
                <v-col  cols="12" md="12">
                  <h4>{{ use_language.additional_details }} : </h4>
                </v-col>
                <v-col cols="12" md="12" class="py-0" >
                  <table>
                    <tr>
                      <td>
                        <v-checkbox
                        
                          v-model="checkbox_abbreviated"
                          :label="use_language.abbreviated_tax_invoice" 
                          hide-details
                          />
                        
                    
                          
                      </td>
                      <td class="pl-2">
                        <v-checkbox
                          v-model="checkbox_headerdetail"
                          :label="use_language.product_details_table"
                          hide-details
                        />
                      </td>

                    </tr>
                    <tr>
                      <td>
                        <v-checkbox
                          v-model="checkbox_Payee_AuthorizedSignatory"
                          :label="use_language.Payee_AuthorizedSignatory"
                          hide-details
                        />
                          
                      </td>
                      <td class="pl-2">
                        <v-checkbox
                        v-model="checkbox_remark"
                        :label="use_language.note"
                        hide-details
                      />
                      </td>

                    </tr>
                  </table>
                </v-col>
              </v-row>
              <v-row  class="pb-4">
                <v-col   class="pt-0"  cols="12" md="12">
                  <h4>{{ use_language.shop_info }} : </h4>
                </v-col>
                <v-col cols="12" md="12"  class="py-0"  >
                  <table>
                    <tr>
                      <td>
                          
                        <v-checkbox
                          v-model="checkbox_shopaddress"
                          :label="use_language.store_address"
                          hide-details
                        />
                          
                      </td>
                      <td class="pl-2">
                        
                        <v-checkbox
                          v-model="checkbox_shoptel"
                          :label="use_language.shop_phone_number"
                          hide-details
                        />
                          
                      </td>

                    </tr>
                  </table>





                </v-col>
              </v-row>
              <v-row  class="pb-4">
                <v-col  class="pt-0"  cols="12" md="12">
                  <h4>{{ use_language.customer_info }} : </h4>
                </v-col>
                <v-col cols="12" md="12"  class="py-0" >
                  <table>
                    <tr>
                      <td>
                      
                        <v-checkbox
                          v-model="checkbox_custmer_address"
                          :label="use_language.customer_address"
                          hide-details
                        />
              
                      </td>
                      <td class="pl-2">
                          

                        <v-checkbox
                          v-model="checkbox_shipingtel"
                          :label="use_language.customer_phone"
                          hide-details
                          /> 
                
                      </td>

                    </tr>
                  </table>





                </v-col>
              </v-row>
            </div>
          </div>
          <v-row no-gutters class="mt-2">
            <v-col :cols="typeOfBill == 3 || typeOfBill == 4 ? '12' : '6'" class="pr-2">
              <v-btn block depressed outlined :disabled="!authorize" :loading="loading" @click="printpdfinvoice()">
                <v-icon left>mdi-printer</v-icon> {{ use_language.print }}
              </v-btn>
            </v-col>
            <v-col cols="6" class="pl-2" v-if="btn_save == null && typeOfBill != 3 && typeOfBill != 4">
              <v-btn block depressed color="info" dark :disabled="!authorize" :loading="loading" @click="saveinvoice()">
                <v-icon left>mdi-content-save</v-icon> {{ use_language.document_storage }}
              </v-btn>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
    </div>
</template>
<script>
  import Loading from '@/website/components/Loading'
  import Swal from "sweetalert2"
  import axios from 'axios'
  import { ref } from 'vue'
  import { reportService_dotnet,generalService_dotnet, orderService_dotnet} from '@/website/global'
  import { format_number, format_order_id, format_price, FormatInvoice,get_languages, set_format_date_time ,checkAuthorize } from '@/website/global_function'
  import { token_api, header_token } from '@/website/backend/token'
  import { order_language } from "@/website/language/order_language";
  import draggable from 'vuedraggable'

export default {
    components: {
      Loading,
      draggable,
    },
    data: () => ({
      shop:JSON.parse(localStorage.getItem("shop")),
      typeOfBill: null,
      genReceiptNo: null,
      genDeliveryNo: null,
      invoiceNoFromMaster: null,
      eSignatureSelect: false,
      eSignature: null,
      eSealSelect: false,
      eSeal: null,

      //
        page_loading: true,
        loading: false,
        use_language: null,
        set_language: null,
        authorize:false,
        phoneNumber:"",
        department:"",
        departmentLabel: "หน่วยงาน",
        namedepartment:"",
        namedepartmentLabel: "เรียน",
        taxID:"",
        deliveryDay:"15",
        createby:"",
        note:"",
        input_transferFileUpload: null,
        input_sealFileUpload: null,
        previewUrl: null,
        previewSealUrl: null,
        bankSelect: false,
        priceSelect: true,
        companyInfoSelect: true,
        docListSelect: true,

        DetailOrderProduct:[],
        Invoice_ID: null,
        INV_Orderid: null,
        INV_Date: null,
        INV_Print:[],
        Data:[],
        dialogsizepage: false,
        btn_save: null,
        Sizepage: 'a4',
        checkbox_custmer_address:true,
        checkbox_abbreviated:false,
        checkbox_shopaddress:true,
        checkbox_shoptel:false,
        checkbox_shipingtel:false,
        checkbox_headerdetail:false,
        checkbox_remark:false,
        checkbox_vat:false,
        checkbox_ppu:false,
        checkbox_detaivat:true,

        checkbox_createdate_order: false,
        checkbox_Payee_AuthorizedSignatory : false,
        createdDatetime_order: null,
        nowDatetime_invoice : null,
        showDatetime_invoice : null,
        inv_titleprintselect: [
              {text: '---กรุณาเลือก---', value: 0},
              {text: 'ใบเสร็จรับเงิน', value: 1},
              {text: 'ใบกำกับภาษี', value: 2},
              {text: 'ใบส่งของ', value: 3},
              {text: 'ใบวางบิล', value: 4},
              {text: 'ใบแจ้งหนี้', value: 5},
              {text: 'ใบเสนอราคา', value: 6},
              {text: 'ใบส่งสินค้า', value: 7},
            ],
      inv_titleprintselect2: [
              {text: 'ใบเสร็จรับเงิน', value: 1},
              {text: 'ใบกำกับภาษี', value: 2}
            ],
      invoice_print: {
        ShopID: localStorage.getItem("shop_id"),
        invorder : [],
        titleprint_main: null,
        titleprint_secondary: null,
        date: new Date().toISOString().substr(0, 10)
      },
    }),
    async created (){
      this.page_loading = true
      //เก็บภาษามาไว้ใน use_language
      this.use_language = await this.get_languages(localStorage.getItem("set_language"));
      //เช็คสิทธิ์แก้ไขหรือดูได้อย่างเดียว
      await this.get_authorize_staffshop();

     if(this.shop.branchID==729)
      {
     
        this.checkbox_abbreviated=true;
        this.checkbox_headerdetail=true;
        this.checkbox_custmer_address= false; 
      }
      await this.getdata_order()
      // await this.get_data_print()
      this.page_loading = false
    },

    watch : {
      eSignatureSelect() {
        if (this.eSignatureSelect == true) {
          this.eSealSelect = false
        }
      },
      eSealSelect() {
        if (this.eSealSelect == true) {
          this.eSignatureSelect = false
        }
      },
    },
    computed: {
      isLastCard() {
        return true; // หรือเขียน logic จริงว่าเป็น card สุดท้าย
      },
      headerDetailOrderProduct() {
        if (!this.use_language) return []
        return [
          { align: 'center', text: 'No', value: 'No', sortable: false, width: '70px'  },
          { align: 'center', text: this.use_language.name_product, value: 'NameProduct', sortable: false  },
          { align: 'center', text: this.use_language.quantity, value: 'Quantity', sortable: false, width: '130px' },
          { align: 'center', text: this.use_language.unit_price, value: 'UnitPrice', sortable: false, width: '130px' },
          { align: 'center', text: this.use_language.discount, value: 'Discount', sortable: false, width: '130px' },
          { align: 'center', text: this.use_language.total_price, value: 'Price', sortable: false, width: '100px' }
        ]
      },
      invorderhead() {
        if (!this.use_language) return []
        return [
          { align: 'center', text: 'OrderID', value: 'orderid', sortable: false  },
          { align: 'center', text: this.use_language.date, value: 'dateString', sortable: false },
          { align: 'center', text: this.use_language.document_number, value: 'invoiceno', sortable: false },
          { align: 'center', text: this.use_language.receipt_no, value: 'receiptNo', sortable: false },
        ]
      },
    },
    methods: {
      get_languages,

      previewImage() {
        const file = this.input_transferFileUpload;
        
        if (file && file.type.startsWith("image/")) {
          this.previewUrl = URL.createObjectURL(file);
        } else {
          this.previewUrl = null;
        }
      },
      previewSealImage() {
        const file = this.input_sealFileUpload;
        
        if (file && file.type.startsWith("image/")) {
          this.previewSealUrl = URL.createObjectURL(file);
        } else {
          this.previewSealUrl = null;
        }
      },
      onMainChange(selected) {
        this.Data[0].titleprint_main = selected
      },
      onSecondaryChange(selected) {
        this.Data[0].titleprint_secondary= selected
      },
    //   convertNumberToThaiText(number) {
    //   const thaiNumbers = ["", "หนึ่ง", "สอง", "สาม", "สี่", "ห้า", "หก", "เจ็ด", "แปด", "เก้า"];
    //   const thaiUnits = ["", "สิบ", "ร้อย", "พัน", "หมื่น", "แสน", "ล้าน"];

    //   let numStr = number.toString();
    //   let result = "";
    //   let len = numStr.length;

    //   for (let i = 0; i < len; i++) {
    //     let digit = parseInt(numStr[i]);
    //     let position = len - i - 1;

    //     if (digit !== 0) {
    //       if (position === 1 && digit === 1) {
    //         result += "สิบ";
    //       } else if (position === 1 && digit === 2) {
    //         result += "ยี่สิบ";
    //       } else if (position === 0 && digit === 1 && len > 1) {
    //         result += "เอ็ด";
    //       } else {
    //         result += thaiNumbers[digit] + thaiUnits[position];
    //       }
    //     }
    //   }

    //   return result + "บาทถ้วน";
    // },
    convertNumberToThaiText(number) {
        const thaiNumbers = ["ศูนย์", "หนึ่ง", "สอง", "สาม", "สี่", "ห้า", "หก", "เจ็ด", "แปด", "เก้า"];
        const thaiUnits = ["", "สิบ", "ร้อย", "พัน", "หมื่น", "แสน", "ล้าน"];

        // แยกส่วนบาทกับสตางค์
        let [bahtPart, satangPart] = number.toString().split(".");
        satangPart = satangPart ? satangPart.substring(0, 2).padEnd(2, "0") : "00";

        function readNumber(numStr) {
          let result = "";
          let len = numStr.length;

          for (let i = 0; i < len; i++) {
            let digit = parseInt(numStr[i]);
            let position = len - i - 1;

            if (digit !== 0) {
              if (position === 1 && digit === 1) {
                result += "สิบ";
              } else if (position === 1 && digit === 2) {
                result += "ยี่สิบ";
              } else if (position === 0 && digit === 1 && len > 1) {
                result += "เอ็ด";
              } else {
                result += thaiNumbers[digit] + thaiUnits[position % 6];
              }
            }

            // ถ้าตำแหน่งเป็นล้าน ให้ใส่ "ล้าน"
            if (position % 6 === 0 && position !== 0) {
              result += "ล้าน";
            }
          }

          return result || "ศูนย์";
        }

        let bahtText = readNumber(bahtPart) + "บาท";
        let satangText = satangPart === "00" ? "ถ้วน" : readNumber(satangPart) + "สตางค์";

        return bahtText + satangText;
      },
      
      calendar_last_row_height (row_len) {
        if(row_len > 0){
          var max_height = 350
          var row_data = row_len
          var fix_height = 39
          var res =  (fix_height*row_data)
          return max_height - res
        } else {
          return 630
        }
      },
        formatDate (date) {
          if (date == null) return null
          if (date != null) {
            const [year, month, day] = date.split('-')
            return `${day}-${month}-${year}`
          }
        },
        updateFormattedDate(item) {
            if (!item.date) return null
            const [year, month, day] = item.date.split('-')
            const buddhistYear = parseInt(year) + 543
            item.dateString = `${day}-${month}-${buddhistYear}`
          },
        toBuddhistDate(value) {
            if (!value) return ''
            const str = String(value)
            let year, month, day
            const iso = str.match(/^(\d{4})-(\d{1,2})-(\d{1,2})/)
            const dmy = str.match(/^(\d{1,2})[-/](\d{1,2})[-/](\d{4})/)
            if (iso) { year = iso[1]; month = iso[2]; day = iso[3] }
            else if (dmy) { day = dmy[1]; month = dmy[2]; year = dmy[3] }
            else return str
            let y = parseInt(year)
            if (y < 2500) y = y + 543
            return `${String(day).padStart(2,'0')}-${String(month).padStart(2,'0')}-${y}`
          },
        async get_orderMaster (order_id){
          try {
            let response = await axios.post(orderService_dotnet+'Order/get-order-master', {
              "orderID": order_id
            },
            { headers: header_token})
            this.createdDatetime_order = (response.data.createdDatetime).substring(0, 10)
          } catch (e) {
            this.loading = false
            Swal.fire({
              position: "top",
              type: "error",
              title: this.use_language.an_error_occurred,
              text: e.message,
            })
          }

        },

        async getdata_order(){

          try {
            this.loading = true
            this.INV_Print = JSON.parse(localStorage.getItem('INVPrint'))
            
            this.typeOfBill = this.INV_Print.type == undefined ? null : this.INV_Print.type
            this.Sizepage = 'a4'//localStorage.getItem('Sizepage')
            await axios.all([
                axios.post(
                  reportService_dotnet+'ShopInvoiceOrder/get-invoice-order',
                {
                  // 'testOrderInvoiceRequest':this.INV_Print
                    'shopID': this.INV_Print.ShopID,
                    'invorder': this.INV_Print.invorder,
                    'titleprint_main': this.INV_Print.titleprint_main,
                    'titleprint_secondary': this.INV_Print.titleprint_secondary,
                },{ headers: header_token}),
                axios.post(generalService_dotnet+'General/get-postcodemapping', {},{ headers: header_token}),
            ])
            .then(axios.spread((Customer,postcodemapping) => {
                if (Customer.status == 200) {
                    this.Data = Customer.data
                    this.Data.titleprint_main = {'text':"ใบเสร็จรับเงิน",'value':1}
                    this.Data.titleprint_secondary = {'text':"ใบกำกับภาษี",'value':2}

                    if (this.INV_Print.titleprint_main == null) {
                      this.INV_Print.titleprint_main = this.Data[0].titleprint_main
                      this.INV_Print.titleprint_secondary = this.Data[0].titleprint_secondary ? this.Data[0].titleprint_secondary : {'text':"ใบกำกับภาษี",'value':2}
                    }

                    this.phoneNumber = Customer.data[0].order[0].customerAddress.phone
                    this.namedepartment = Customer.data[0].order[0].customerAddress.name
                    this.department = Customer.data[0].order[0].customerAddress.name
                    this.taxID = Customer.data?.[0]?.order?.[0]?.customerAddress?.taxID || ''
                    this.eSignature = Customer.data[0].e_Signature
                    this.eSeal = Customer.data[0].e_Seal
                }
            }));
            if (this.typeOfBill == 2 || this.typeOfBill == 3 || this.typeOfBill == 4) {
              var billNo = await this.genBillNo()
              this.invoiceNoFromMaster = billNo.invoiceNo
              if (billNo.invoiceNo != null) {
                this.Data[0].order[0].invoiceNo = billNo.invoiceNo
              }
              if (this.typeOfBill == 3) { 
                this.genReceiptNo = billNo.billNo 
              } else if (this.typeOfBill == 4) { 
                this.genDeliveryNo = billNo.billNo 
              }
              if (this.typeOfBill != 2 && this.INV_Print.ShopID == 8985) {
                this.Data[0].order[0].invoiceNo = billNo.billNo 
              }
              if(this.typeOfBill == 2 || this.typeOfBill == 3 && this.INV_Print.ShopID == 8985) {
                this.Data[0].order[0].invoiceNo = billNo.invoiceNo ?? this.INV_Print.invorder[0].invoiceNo
              }
            } else if (this.typeOfBill == 1 && this.INV_Print.ShopID == 8985) {
              this.Data[0].order[0].invoiceNo = this.INV_Print.billNo
            }
            this.loading = false
          } catch (e) {
            this.loading = false
            Swal.fire({
              position: "top",
              type: "error",
              title: this.use_language.an_error_occurred,
              text: e.message,
            })
          }


        },
        async genBillNo() {
          let response = await axios.post(
            reportService_dotnet+'ShopInvoiceOrder/gen-receipt-or-delivery-no',
            {
              "orderMasterID": this.INV_Print.invorder[0].orderId,
              "shopID": parseInt(this.INV_Print.ShopID),
              "type": this.typeOfBill
            },
            { headers: header_token}
          )
          return response.data
        },
        async updateBillNo() {
          var orderId = this.INV_Print.invorder[0].orderId
          let response = await axios.post(
            reportService_dotnet+'ShopInvoiceOrder/update-receipt-or-delivery-no',
            {
              "orderMasterID": orderId,
              "receiptNo": this.typeOfBill == 3 ? this.genReceiptNo : null,
              "deliveryNo": this.typeOfBill == 4 ? this.genDeliveryNo : null,
              "invoiceNo": this.Data[0].order[0].invoiceNo,
              "type": this.typeOfBill
            },
            { headers: header_token}
          )
        },
        async printpdfinvoice(){
           setTimeout(() => {
            print()
          }, 500); //
          if (this.typeOfBill == 2 || this.typeOfBill == 3 || this.typeOfBill == 4) {
            this.updateBillNo()
          }
        },
        async get_invoiceid(){
          try {
            this.loading = true
            axios.all([
              axios.post(reportService_dotnet+'ShopInvoiceOrder/check-invoice-order', {
                  'ShopID': this.INV_Print.shopID,
                  'printorder': this.INV_Print.printorder,
                  'StaffID': localStorage.getItem("staff_id"),
              },{ headers: header_token}),
            ])
            .then(axios.spread((invoice) => {
              if (invoice.status == 200) {
                if (invoice.data == true) {
                  this.btn_save = 1
                }
              } else {
                  this.$swal({
                      type: 'warning',
                      title: this.use_language.warning_error_try_again,
                  })
              }
            }));
            this.loading = false
          } catch (e) {
            this.loading = false
            Swal.fire({
              position: "top",
              type: "error",
              title: this.use_language.an_error_occurred,
              text: e.message,
            })
          }

        },
        async saveinvoice(){

          try {
            this.loading = true
            localStorage.setItem('DataPrint',  JSON.stringify(this.Data))
            
            axios.all([
              axios.post(reportService_dotnet+'ShopInvoiceOrder/insert-invoice-order', {
                  'ShopID': this.INV_Print.ShopID,
                  'invorder': this.Data[0].order,
                  'titleprint_main': this.Data[0].titleprint_main,
                  'titleprint_secondary': this.Data[0].titleprint_secondary,
                  'StaffID': localStorage.getItem("staff_id"),
              },{ headers: header_token}),
            ])
            .then(axios.spread((invoice) => {
              if (invoice.status == 200) {
                 
                this.$swal({
                    type: 'success',
                    title: invoice.data,
                })
              } else {
                  this.$swal({
                      type: 'warning',
                      title: this.use_language.warning_error_try_again,
                  })
              }
            }));
            this.loading = false
          } catch (e) {
            this.loading = false
            Swal.fire({
              position: "top",
              type: "error",
              title: this.use_language.an_error_occurred,
              text: e.message,
            })
          }

        },
         
        async get_authorize_staffshop () {
          if(this.checkAuthorize(24) == true || this.checkAuthorize(25) == true )
          {
           this.authorize = true
          }
        },
        format_number,
        format_order_id,
        format_price,
        FormatInvoice,
        set_format_date_time,
        checkAuthorize,
    }
}
</script>
<style scoped>
  @import url("https://fonts.googleapis.com/css?family=Sarabun");

    >>>.set-font-size thead tr th{

      font-weight: bold !important;
      font-size: 11px !important;
    }

    /* border table */
    table {
      border-collapse: collapse;
    }

    >>>.border-left{
      border-left: 1px solid black !important;
    }
    >>>.border-right{
      border-right: 1px solid black !important;
    }
    >>>.border-top{
      border-top: 1px solid black !important;
    }
    >>>.border-bottom{
      border-bottom: 1px solid black !important;
    }
    >>>.border-x{
      border-left: 1px solid black !important;
      border-right: 1px solid black !important;
    }
    >>>.border-y{
      border-top: 1px solid black !important;
      border-bottom: 1px solid black !important;
    }
    >>>.border-a{
      border: 1px solid black !important;
    }
    @media print {
      
      
      body * {
      visibility: hidden !important;
      background: white !important;
      margin: 0;
      padding: 0;
    }
      #print-area,
      #print-area * {
        visibility: visible !important;
      }
      .font {
        font-family: "Sarabun", sans-serif;
      }
      .force-black {
        background-color: black !important;
        color: white !important;
        -webkit-print-color-adjust: exact;
        print-color-adjust: exact;
      }
      .break-print {
        break-after: page;
      }
      .page-break {
        page-break-before: always;
      }
      .page-break:last-child {
        break-after: auto; /* ไม่ break ถ้าเป็นตัวสุดท้าย */
      }


      #print-area {
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
      }
      .print-only { }
      .screen-only {display: none;}
      .size-picNew{
        margin-top: 4px;
        width: 100%
      }
      .size-pic{
        margin-top: 4px;
        width: 100%
      }
      .font-size-inv{
        font-size: 0.6rem !important;
      }
      .font-size-print{
          font-size: 0.8rem !important;
          color-adjust: exact;
          color: #000000;
        }
      .fonttitle-print{
        font-size: 0.75rem !important;
        font-weight: 600 !important
      }
      .pages {
        size: 80mm 80mm;
        width: 80mm;
        height: 80mm;
        margin: 0;
        margin-left: 4px !important;
        margin-right: 4px !important;
        margin-top: 2px !important;
        margin-bottom: 0px !important;
      }
    }
    @media screen {
        .font {
          font-family: "Sarabun", sans-serif;
        }
        .print-only {
          display: none;
        }
        .screen-only {}
        .size-pic{
          width: 100%
        }
        .fonttitle-print{
          font-size: 1rem !important;
          font-weight: 700 !important
        }
        .pages{
        width: 100mm;
        height: auto;
        margin: 0;
        margin-top: 2px !important;
        margin-left: 2px  !important;
        margin-right: 2px  !important;
        padding-left: 2px !important;
      }
    }
</style>
